import ApiService from "@/core/services/api.service";

// action types
export const FETCH_LIVES = "fetchLives";
export const FETCH_LIVE = "fetchLive";
export const STOP_LIVE = "stopLive";
export const FETCH_ACTIVE_LIVES = "fetchActiveLives";
export const FETCH_LIVE_DESTINATIONS = "fetchLiveDestinations";
export const FETCH_LIVE_DESTINATION = "fetchLiveDestination";
export const FETCH_LIVE_DESTINATION_COMMENT = "fetchLiveDestinationComment";
export const FETCH_LIVE_DESTINATION_VIEWERS = "fetchLiveDestinationViewers";
export const STORE_LIVE_DESTINATION_COMMENT = "storeLiveDestinationComment";
export const PIN_LIVE_DESTINATION_COMMENT = "pinLiveDestinationComment";
export const UNPIN_LIVE_DESTINATION_COMMENT = "unpinLiveDestinationComment";

// mutation types
export const SET_LIVES = "setLives";
export const SET_LIVES_PAGINATION = "setLivesPagination";
export const SET_LIVE = "setLive";
export const SET_LIVE_DESTINATIONS = "setLiveDestinations";
export const SET_LIVE_DESTINATION = "setLiveDestination";
export const SET_ACTIVE_LIVES = "setActiveLives";
export const SET_LIVE_DESTINATION_COMMENT = "setLiveDestinationComment";
export const SET_LIVE_DESTINATION_VIEWERS = "setLiveDestinationViewers";
export const SET_LIVE_DESTINATION_VIEWERS_PAGINATION =
  "setLiveDestinationViewersPagination";

const state = {
  lives: [],
  livesPagination: {
    total: 0,
    currentPage: 1,
    firstPage: 1,
    lastPage: 1,
    perPage: 0
  },
  live: [],
  liveDestinations: [],
  liveDestination: [],
  activeLives: [],
  liveDestinationsComments: [],
  liveDestinationsViewers: [],
  liveDestinationsViewersPagination: []
};

const getters = {
  lives(state) {
    return state.lives;
  },
  livesPagination(state) {
    return state.livesPagination;
  },
  live(state) {
    return state.live;
  },
  liveDestinations(state) {
    return state.liveDestinations;
  },
  liveDestination(state) {
    return state.liveDestination;
  },
  activeLives(state) {
    return state.activeLives;
  },
  liveDestinationsComments(state) {
    return state.liveDestinationsComments;
  },
  liveDestinationsViewers(state) {
    return state.liveDestinationsViewers;
  },
  liveDestinationsViewersPagination(state) {
    return state.liveDestinationsViewersPagination;
  }
};

const actions = {
  [FETCH_LIVES](context, programId) {
    return new Promise((resolve, reject) => {
      ApiService.query(
        `programs/${programId}/lives`,
        {
          params: {
            page: context.state.livesPagination.currentPage
          }
        },
        false
      )
        .then(({ data }) => {
          context.commit(SET_LIVES, data.data);
          context.commit(SET_LIVES_PAGINATION, {
            total: data["total"],
            currentPage: data["current_page"],
            firstPage: data["first_page"],
            lastPage: data["last_page"],
            perPage: data["per_page"]
          });
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [FETCH_LIVE](context, liveId) {
    return new Promise((resolve, reject) => {
      ApiService.get(`lives/${liveId}`, "", false)
        .then(({ data }) => {
          context.commit(SET_LIVE, data);
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [FETCH_LIVE_DESTINATIONS](context, liveId) {
    return new Promise((resolve, reject) => {
      ApiService.get(`lives/${liveId}/destinations`)
        .then(({ data }) => {
          context.commit(SET_LIVE_DESTINATIONS, data);
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [FETCH_LIVE_DESTINATION](context, liveDestinationId) {
    return new Promise((resolve, reject) => {
      ApiService.get(`liveDestinations/${liveDestinationId}`)
        .then(({ data }) => {
          context.commit(SET_LIVE_DESTINATION, data);
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [STOP_LIVE](context, live) {
    return new Promise((resolve, reject) => {
      ApiService.patch(`lives/${live}/stop`, {})
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [FETCH_ACTIVE_LIVES](context) {
    return new Promise((resolve, reject) => {
      ApiService.query("lives", {
        params: {
          status: "active"
        }
      })
        .then(({ data }) => {
          context.commit(SET_ACTIVE_LIVES, data);
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [FETCH_LIVE_DESTINATION_VIEWERS](context, liveDestination) {
    return new Promise((resolve, reject) => {
      ApiService.query(
        `liveDestinations/${liveDestination}/viewers`,
        {
          params: {
            page: context.state.livesPagination.currentPage
          }
        },
        false
      )
        .then(({ data }) => {
          context.commit(SET_LIVE_DESTINATION_VIEWERS, data?.viewers);
          context.commit(SET_LIVE_DESTINATION_VIEWERS_PAGINATION, {
            total: data["total"],
            currentPage: data["current_page"],
            firstPage: data["first_page"],
            lastPage: data["last_page"],
            perPage: data["per_page"]
          });
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [FETCH_LIVE_DESTINATION_COMMENT](context, liveDestination) {
    return new Promise((resolve, reject) => {
      ApiService.query(
        `liveDestinations/${liveDestination}/comments`,
        {
          params: {
            page: context.state.livesPagination.currentPage
          }
        },
        false
      )
        .then(({ data }) => {
          context.commit(SET_LIVE_DESTINATION_COMMENT, data);
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [STORE_LIVE_DESTINATION_COMMENT](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post(
        `liveDestinations/${payload.liveDestination}/comments`,
        payload
      )
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [PIN_LIVE_DESTINATION_COMMENT](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post(
        `liveDestinations/${payload.liveDestination}/comments/pin`,
        payload
      )
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [UNPIN_LIVE_DESTINATION_COMMENT](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post(
        `liveDestinations/${payload.liveDestination}/comments/unpin`,
        payload
      )
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  }
};

const mutations = {
  [SET_LIVES](state, lives) {
    state.lives = lives;
  },
  [SET_LIVES_PAGINATION](state, data) {
    state.livesPagination = data;
  },
  [SET_LIVE](state, live) {
    state.live = live;
  },
  [SET_LIVE_DESTINATIONS](state, liveDestinations) {
    state.liveDestinations = liveDestinations;
  },
  [SET_LIVE_DESTINATION](state, liveDestination) {
    state.liveDestination = liveDestination;
  },
  [SET_ACTIVE_LIVES](state, payload) {
    state.activeLives = payload;
  },
  [SET_LIVE_DESTINATION_COMMENT](state, payload) {
    state.liveDestinationsComments = payload;
  },
  [SET_LIVE_DESTINATION_VIEWERS](state, payload) {
    state.liveDestinationsViewers = payload;
  },
  [SET_LIVE_DESTINATION_VIEWERS_PAGINATION](state, payload) {
    state.liveDestinationsViewersPagination = payload;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
